// ops-settings.ts — (B113; planning 10-24 22:30, 23:00; Creative 2's C2.13) the Operations page's words about a setting,
// pure: when a change applies (the registry's perRun), the engine's own value (or that it isn't readable from here —
// never this backend's .env default), and what a save answered (how many running videos keep the old value).
import type { OpsThreshold, SaveAnswer } from "@/api/operations.ts";
import { w } from "./words.ts";

/** "applies to new runs" (pinned) · "applies at once" (live) · nothing (the setting declares no mode). */
export function modeLabel(perRun: OpsThreshold["perRun"]): string | null {
  return perRun === "pinned" ? w("page.ops.applies_new_runs") : perRun === "live" ? w("page.ops.applies_at_once") : null;
}

/** The engine's value of a workers' setting, said: its value and where it comes from, or not readable (null: not the engine's). */
export function engineLine(t: Pick<OpsThreshold, "engineOwned" | "engine">): { text: string; readable: boolean; why?: string } | null {
  if (!t.engineOwned || !t.engine) return null;
  if (!t.engine.readable) return { text: w("page.ops.engine_not_readable"), readable: false, why: t.engine.why };
  const value = t.engine.value === null ? "—" : String(t.engine.value);
  return { text: w("page.ops.engine_value", { value, source: w(`page.ops.source.${t.engine.source}`) }), readable: true };
}

/** What a save answered, in words: "applies to new runs · 3 running videos keep the old value", "applies at once", or nothing. */
export function savedLine(a: Pick<SaveAnswer, "appliesTo" | "runsKeepingOld">): string | null {
  if (a.appliesTo === "at_once") return w("page.ops.applies_at_once");
  if (a.appliesTo !== "new_runs") return null;
  const n = a.runsKeepingOld;
  const keep = n === null || n === undefined ? w("page.ops.runs_keep_old.unknown") : n === 0 ? w("page.ops.runs_keep_old.none")
    : n === 1 ? w("page.ops.runs_keep_old.one") : w("page.ops.runs_keep_old.many", { n });
  return `${w("page.ops.applies_new_runs")} · ${keep}`;
}
